import Component from './component'
import {connect} from 'react-redux'

const mapStateToProps = (state) =>{
    return {
        lotes : state.database.vendas.toArray(),
        corretores : state.database.corretores.toArray()
    }
}

export default connect(mapStateToProps)(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/corretores/container.js